import graphql__a72d579c87e19874710b from "./__generated__/FeaturedContentBlockImage_block.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import ButtonLink from "../Buttons/ButtonLink";

const FeaturedContentBlockImage = props => {
  const { url, originalImage } = props.block;

  const imageUrl = originalImage.large.url;

  return (
    <ButtonLink
      href={url}
      className="content-block-image btn btn-unstyled padding-none box-shadow w-100 h-100"
    >
      {originalImage && (
        <img className="rounded w-100 h-100" src={imageUrl} alt={originalImage.altText} />
      )}
    </ButtonLink>
  );
};

export default createFragmentContainer(FeaturedContentBlockImage, {
  block: graphql__a72d579c87e19874710b
});
